import { useEffect, useState } from "react";
import { TRANSACTION_EXPIRATIONS } from "../../constants/api";
import { Bounce, ToastContainer } from "react-toastify";
import { errorNotify, successNotify } from "../../shared/notifications";
import axiosHttp from "../interceptors/axios-interceptor";
import { persianLanguage } from "../../constants/persianTerms";
import { Button, NumberBox } from "devextreme-react";
import { useParams } from "react-router-dom";
import TransactionExpirationDurationHistory from "./transaction-expiration-duration-history/transaction-expiration-duration-history";
import { persianPrice } from '../../shared/persian-number';
import { useAuth } from "../auth/auth-provider/auth-provider";

export default function TransactionExpirationDuration(){
    

    const [transactionExpirationDuration, setTransactionExpirationDuration] = useState();

    const [duration, setDuration] = useState(0);
    const [newValue, setNewValue] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);


    const auth = useAuth();

    useEffect(() => {
        getTransactionExpirationDuration();
    }, [newValue]);

    const getTransactionExpirationDuration = () => {
        axiosHttp.get(`${TRANSACTION_EXPIRATIONS}${auth?.user?.id}/`).then(
            response => {
                setTransactionExpirationDuration(response.data);
                setDuration(response.data.expirationDuration);
            }
        ).catch(
            error => {
                setTransactionExpirationDuration(null)
                setDuration(0);
            }
        );
    }

    const handlePrice = (e) =>{
        // console.log('e issssssss: ', e)
        setNewValue(e.event.target.value);
    }

    const changeCreditValue = () => {
        const formData = new FormData()
        formData.append('expirationDuration', newValue);
        const api = `${TRANSACTION_EXPIRATIONS}${auth?.user?.id}/`;
        axiosHttp.patch(api, formData).then(
            response => {
                successNotify(`
                    ${persianLanguage.phrase.success.SUCCESS_201}
                    `);
                    setNewValue(null);
            }
        ).catch(
            error => {
                // console.log('error is', error)
                if(error.response.status === 403){
                    errorNotify(persianLanguage.phrase.error.ERROR_403);
                } else if(error.response.status === 404){
                    
                }
                else if (error.response.status === 500){
                    errorNotify(persianLanguage.phrase.error.ERROR_500);
                }
                else{
                    errorNotify(persianLanguage.phrase.error.ERROR_400);
                }
            }
        );
    }
    const handleSubmit = () => {
        if( newValue === 0 || newValue === null){
            setErrorMessage(persianLanguage.phrase.required.AMOUNT_REQUIRED);
        } else {
            setErrorMessage(null);
            changeCreditValue();
        }
    }

    return (
        <>
            {/* <ToastContainer 
                rtl={true}
                position="top-right"
                theme="dark"
                draggable
                transition={Bounce} 
            /> */}
            <div className="grid md:grid-cols-3  grid-cols-1 golden-border-2 m-4 user-select-none" >
                <div className=' place-items-center md:text-right sm:text-right  text-center mt-5'>
                    {persianLanguage.phrase.transaction.AUTOMATIC_TRANSACTION_EXPIRATION_DURATION}

                    <span className="golden-background px-1 mx-1 rounded">{persianPrice(duration)} </span>
                    {transactionExpirationDuration && <span> {persianLanguage.word.time.SECOND}</span>}
                </div>
                <div className=' place-items-center justify-content-center mt-5'> 

                </div>
                <div>
                <form onSubmit={handleSubmit}>
                    <div>
                        <div class="grid md:grid-cols-2 grid-cols-1 gap-1  ">
                        <div>
                            <NumberBox
                            value={newValue}
                            className="mt-5"
                            rtlEnabled={true}
                            placeholder={persianLanguage.phrase.transaction.RECORD_NEW_TRANSACTION_EXPIRATION_DURATION}
                            onChange={(e) => handlePrice(e)}
                            />
                            {errorMessage && <span className='bg-red-100 border border-red-500 text-red-700 px-4 py-1 rounded relative'>{errorMessage}</span>}
                        </div>
                        <div className='flex justify-end'>
                            <Button
                            width={90}
                            text={persianLanguage.word.general.REGISTER}
                            className="golden-button content-end mt-5"
                            stylingMode="outlined"
                            onClick={(e) => handleSubmit(e)}/>
                        </div>
                        </div>
                        <div>
                        </div>
                    </div>
                </form>

                </div>
            </div>
            <hr className="golden-hr" />
            <TransactionExpirationDurationHistory duration={newValue} />
        </>
    );
}